import { render } from "./EscolaCrescimento.vue?vue&type=template&id=2078e2d2&scoped=true&lang=pug"
import script from "./EscolaCrescimento.vue?vue&type=script&setup=true&lang=js"
export * from "./EscolaCrescimento.vue?vue&type=script&setup=true&lang=js"

import "./EscolaCrescimento.vue?vue&type=style&index=0&id=2078e2d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2078e2d2"]])

export default __exports__